import axios from "@/plugins/axios";

export const state = () => ({
  token: null,
  refreshToken: null,
  status: false,
  keyShortcuts: {},
  help_tooltip_visible: false,
  user: {
    first_name: null,
    last_name: null,
  },
});

export const mutations = {
  SET_TOKEN: function(state, token) {
    state.token = token;
    localStorage.setItem("pos_token", token);
  },
  MAKE_TOOLTIP_VISIBLE: function(state, payload) {
    state.help_tooltip_visible = payload;
  },
  SET_KEY_SHORTCUTS: function(state, payload) {
    state.keyShortcuts = payload;
  },
  SET_REFRESH_TOKEN: function(state, token) {
    state.refreshToken = token;
  },
  SET_USER: function(state, payload) {
    state.user = payload;
  },
  SET_STATUS: function(state, payload) {
    state.status = payload;
  },
};

export const actions = {
  makeVisibleTooltip({ commit }, payload) {
    commit("MAKE_TOOLTIP_VISIBLE", payload);
  },
  Login({ commit, dispatch }, credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post("auth/login", credentials)
        .then((res) => {
          commit("SET_TOKEN", res.data.accessToken);
          commit("SET_REFRESH_TOKEN", res.data.refreshToken);
          // ;
          commit("SET_STATUS", false);

          dispatch("fetchUserInfo");
          dispatch("getAllPosKeys");
          dispatch("fetchAllData", null, { root: true });

          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async LogOut({ commit }) {
    return new Promise((resolve, reject) => {
      commit("SET_USER", null);
      commit("SET_STATUS", false);
      resolve(true);
    });
  },
  fetchUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("auth/user")
        .then((res) => {
          commit("SET_USER", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getAllPosKeys({ commit, rootGetters }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`settings/pos-shortcut/1`)
        .then((res) => {
          commit("SET_KEY_SHORTCUTS", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export const getters = {
  GetUser: (state) => {
    return state.user;
  },
  GetUserName: (state) => {
    // if (state.user?.last_name) return state.user.last_name;
    // else return "";

    // var name = "";
    // if (state.user.first_name) {
    //   name = state.user.first_name + " ";
    // }
    // if (state.user.last_name) {
    //   name = name + state.user.last_name;
    // }
    // return name;
    return state.user.first_name
      ? state.user.first_name
      : "" + state.user.first_name
      ? " "
      : "" + state.user.last_name
      ? state.user.last_name
      : "";
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
